import { useTranslation } from 'react-i18next';
import { SelectionPickerDialog } from '@/components';
import { useCompanyPossibleLevels } from '../hooks';
import type { Level } from '../models';

interface SelectCompanyLevelProps {
  isOpen: boolean;
  companyId: string;
  selectedLevelId?: string;
  isUpdating?: boolean;
  onClose: () => void;
  onSelect: (level: Level) => void | Promise<void>;
}

export function SelectCompanyLevel({
  isOpen,
  companyId,
  selectedLevelId,
  isUpdating = false,
  onClose,
  onSelect,
}: SelectCompanyLevelProps) {
  const { t } = useTranslation();
  const { data: availableLevels = [], isLoading: isLoadingLevels } = useCompanyPossibleLevels(companyId, isOpen);

  // Transform levels to the format expected by SelectionPickerDialog
  const values = availableLevels.map((level) => ({
    id: level.id,
    value: level.name,
  }));

  // Handle selection - find the full level object and call onSelect
  const handleSelect = async (selectedId: string) => {
    const selectedLevel = availableLevels.find((level) => level.id === selectedId);
    if (selectedLevel) {
      await onSelect(selectedLevel);
    }
  };

  return (
    <SelectionPickerDialog
      isOpen={isOpen}
      onClose={onClose}
      header={t('companyAdmin.form.changeLevelTitle')}
      subheader={t('companyAdmin.form.changeLevelWarning')}
      isLoading={isLoadingLevels}
      values={values}
      isUpdating={isUpdating}
      onSelect={handleSelect}
      selectedId={selectedLevelId}
    />
  );
}
